import { renderTask } from "./taskRenderer";
import { isArrayEmpty } from "..";

import autoAnimate from "@formkit/auto-animate";
import { updateArrayindb } from "../firebase/db";
const taskContainer = document.querySelector(".notesContainer");
autoAnimate(taskContainer)

export let tasksArray = [];

export function setTasksArray(arr) {
  tasksArray = arr;
}

export function formHandling() {
  const title = document.getElementById("taskTitle").value;
  const description = document.getElementById("taskDescription").value;
  const dueDate = document.getElementById("taskDueDate").value;
  const selectedProjectId_string = document.querySelector(
    'select[name="project"]'
  ).value;

  const selectedProjectId = parseInt(selectedProjectId_string);

  const taskObject = createTaskObject(
    title,
    description,
    dueDate,
    selectedProjectId
  );

  tasksArray.push(taskObject);
  renderTask(taskObject);
  // localStorage.setItem("tasksArray", JSON.stringify(tasksArray));
  updateArrayindb('tasks',tasksArray)
}

let taskIdCounter;
function createTaskObject(title, description, dueDate, projectId) {
  if (isArrayEmpty(tasksArray)) {
    taskIdCounter = 0;
  } else {
    const lastElement = tasksArray[tasksArray.length - 1];
    taskIdCounter = lastElement.id + 1;
  }
  let task = {
    id: taskIdCounter,
    title: title,
    description: description,
    dueDate: dueDate,
    projectId: projectId,

    completed: false,
  };
  taskIdCounter++;
  return task;
}

export function deleteButtonHandler(button, taskId) {
  tasksArray = tasksArray.filter((tasks) => tasks.id !== taskId);

  // localStorage.setItem("tasksArray", JSON.stringify(tasksArray));
  updateArrayindb('tasks',tasksArray)
  const noteDiv = button.closest(".task");
  console.log(noteDiv);
  if (noteDiv) {
    noteDiv.remove();
  }
}

export function checkboxHandler(taskId, isChecked) {
  // console.log(a);
  // console.log(b.target.checked);
  const task = tasksArray.find((task) => task.id === taskId);
  const taskElement = document.getElementById(`task-${taskId}`);
  if (task) {
    task.completed = isChecked;
    console.log(`Task ${taskId} updated:`, task);

    //strikethough logic
    if (isChecked) {
      taskElement.classList.add("line-through", "opacity-50");
      //if checked move to the last of the list
      taskContainer.appendChild(taskElement);
    } else {
      taskElement.classList.remove("line-through", "opacity-50");
    }
  }
  // localStorage.setItem("tasksArray", JSON.stringify(tasksArray));
  updateArrayindb('tasks',tasksArray)
}
export function detailsButtonHandler(taskId) {
  let taskDetails = tasksArray[taskId].description;
  const modal = document.getElementById("detailsModal");
  const taskDescription = document.getElementById("taskDetails");

  if (taskDetails === "") {
    taskDetails = "No Details Added for this task";
  }
  taskDescription.textContent = taskDetails;
  modal.showModal();

  const closeModal = document.getElementById("closeModal");
  closeModal.addEventListener("click", () => {
    modal.close();
  });
}
